import React, { useEffect, useState, useContext } from 'react';
import { modalContext } from '@/context/modal.context';
import { toastContext } from '@/context/toast.context';
import { AccountContext } from '@/context/account.context';
import classes from './UserVerification.module.scss';
import Button from '@/components/Button/Button';
import t from '@/utils/Language/Documents-translations';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'react-loading-skeleton/dist/skeleton.css';
import { resourceHelpers } from '@/utils/helpers';
import UserAccount from '@/utils/api/odas/user_account';

const UserVerification = () => {
  const { enqueueModal } = useContext(modalContext);
  const { addToast } = useContext(toastContext);
  const [emailExist, setEmailExist] = useState(false);
  const [phoneExist, setPhoneExist] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [confirmationEmail, setConfirmationEmail] = useState();
  const [confirmationCellPhone, setConfirmationCellPhone] = useState();
  const [emailVerificationActive, setEmailVerificationActive] = useState(true);
  const [phoneVerificationActive, setPhoneVerificationActive] = useState(true);
  const account = useContext(AccountContext);

  const toggleButtonInterval = 2000;
  const typeLabel = {
    email: 'email',
    text: 'cell phone'
  };

  const capitalize = (str) => {
    return str.replace(/^./, (str) => str.toUpperCase());
  };

  const accountUpdated = (type) => {
    account.getUserInfo();
    let message = `${capitalize(typeLabel[type])} saved successfully.`;
    addToast({
      message: t(message),
      type: 'success'
    });
  };

  const updateContact = (type, value = '') => {
    let title = `Edit ${typeLabel[type]}`;
    let fieldLabel = typeLabel[type];

    enqueueModal({
      type: type,
      fieldLabel: fieldLabel,
      name: 'UpdateUserContactModal',
      value: value,
      user: userInfo,
      // showCancel: false,
      title: t(title),
      preventClose: false,
      onConfirm: () => accountUpdated(type)
    });
  };

  useEffect(() => {
    const user = account.data;
    if (user) {
      setUserInfo(user);
      setEmailExist(user.email ? true : false);
      setPhoneExist(user.cell_phone ? true : false);
      setConfirmationEmail(user.email);
      setConfirmationCellPhone(user.cell_phone);
    }
  }, [account.data]);

  // Inactivate and then active buttons with some time interval to avoid multiple clicks at same the time
  const toggleVerificationButtons = (type) => {
    if (type === 'email') {
      setEmailVerificationActive(false);
      setTimeout(() => {
        setEmailVerificationActive(true);
      }, toggleButtonInterval);
    } else if (type === 'text') {
      setPhoneVerificationActive(false);
      setTimeout(() => {
        setPhoneVerificationActive(true);
      }, toggleButtonInterval);
    }
  };

  const sendVerificationBy = (type) => {
    toggleVerificationButtons(type);
    UserAccount.sendVerification(type).then((resp) => {
      let message = `${capitalize(typeLabel[type])} verification sent!`;
      addToast({
        message: t(message),
        type: 'success'
      });
    });
  };

  return (
    <>
      <Col xs={12} sm={{ span: 10, offset: 1 }} md={{ span: 8, offset: 2 }} lg={{ span: 4, offset: 4 }}>
        <div className={`${classes.stateContainer}`}>
          <p
            className={`${[classes.contentTop, classes.textAlignLeft].join(' ')}`}
            dangerouslySetInnerHTML={{ __html: t('To start using Documents, please verify your account with your email or cell phone number.') }}
          ></p>
          {emailExist === true ? (
            <>
              <p className={`${classes.textAlignLeft}`}>
                <div className={`${classes.smallContent}`}>
                  <FontAwesomeIcon icon={['fa', 'envelope']} /> {t('Your email')}
                </div>
                <div>
                  {confirmationEmail}
                  <span className={`${classes.plainLink}`}>
                    <Button type="link" onButtonClick={() => updateContact('email', confirmationEmail)} text={t('Update')} />
                  </span>
                </div>
              </p>
              <p>
                <Button
                  type="primary"
                  text={t('Send email verification')}
                  disabled={!emailVerificationActive}
                  styles={{ width: 'full' }}
                  onButtonClick={() => sendVerificationBy('email')}
                />
              </p>
            </>
          ) : (
            ''
          )}
          {emailExist === true && phoneExist === true ? (
            <p>
              <strong>{t('OR')}</strong>
            </p>
          ) : (
            ''
          )}
          {phoneExist === true ? (
            <>
              <p className={`${classes.textAlignLeft}`}>
                <div className={`${classes.smallContent}`}>
                  <FontAwesomeIcon icon={['fa', 'mobile-alt']} /> {t('Your cell phone')}
                </div>
                <div>
                  {resourceHelpers.formatPhoneNumber(confirmationCellPhone)}
                  <span className={`${classes.plainLink}`}>
                    <Button type="link" onButtonClick={() => updateContact('text', confirmationCellPhone)} text={t('Update')} />
                  </span>
                </div>
              </p>
              <p>
                <Button
                  type="primary"
                  text={t('Send text verification')}
                  disabled={!phoneVerificationActive}
                  styles={{ width: 'full' }}
                  onButtonClick={() => sendVerificationBy('text')}
                />
              </p>
            </>
          ) : (
            ''
          )}
        </div>
      </Col>
      <Col xs={12} sm={{ span: 10, offset: 1 }} md={{ span: 8, offset: 2 }} lg={{ span: 4, offset: 4 }}>
        <div className={`${classes.disclaimerContainer}`}>
          <div className={`${classes.smallContentHeading}`}>{t('Have issues verifying your account?')}</div>
          <div
            className={`${classes.smallContent}`}
            dangerouslySetInnerHTML={{
              __html: t('Please email us at help@1degree.org or text us anytime at (800) 484-0126. We will respond within 1-3 business days.')
            }}
          ></div>
        </div>
      </Col>
    </>
  );
};

export default UserVerification;
